/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {CURRENCY_MASK_CONFIG as ɵa} from './src/currency-mask.config';